var _ellipse, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.788 393.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.394,
    cy: 77.602,
    rx: 68.984,
    ry: 71.935,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11.333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.41,
    y: 77.602,
    width: 137.968,
    height: 71.935,
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 11.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332.863,270.79c-10.57-41.578-21.159-83.318-31.763-125.22-3.858-8.316-15.046-29.071-40.174-42.815-7.958-4.371-15.874-7.281-23.327-9.217-7.455-2.527-15.549-3.767-24.003-3.486-7.044-.262-12.611.169-15.884.511-17.542.438-35.093.438-52.635,0-3.274-.342-8.84-.773-15.884-.511-8.454-.282-16.548.959-24.003,3.486-7.453,1.937-15.37,4.846-23.327,9.217-25.128,13.745-36.317,34.499-40.174,42.815-10.604,41.902-21.193,83.642-31.763,125.22-8.543,29.701-1.16,63.435,19.684,86.544,17.944,19.898,39.766,24.542,47.471,25.669,17.493,1.571,35.016,2.704,52.552,3.399,27.83,1.103,55.692,1.103,83.522,0,17.536-.695,35.059-1.828,52.552-3.399,7.704-1.127,29.527-5.771,47.471-25.669,20.844-23.109,28.228-56.843,19.685-86.544Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12.879
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.9dd661ae259922342eb32c620ce88e2a.svg";
export { ForwardRef as ReactComponent };